module.exports = __webpack_public_path__ + "img/Wallis and Futuna.efebe290.svg";